<app-template>

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="container-privacy">
            <div class="header-privacy">
                <h1><p>
                    Termos e<br>Condições
                </p></h1>
            </div>
            <div class="privacy-content">
                <p class="date">
                </p>
                <p>
                    Estes Termos e Condições de uso da Plataforma FAD (“Termos”), regem a aquisição, acesso e utilização
                    da plataforma de Assinatura Autógrafa Digital (“FAD”) e outros serviços e produtos relacionados,
                    comercializados pela <strong>BIOMETRIC AGREEMENT DO BRASIL LTDA (“BIOMETRIC” ou “nós”)</strong>
                    através de nosso
                    aplicativo, Plataforma Digital ou website. Dessa forma, estes Termos vinculam todas aquelas pessoas
                    ou entidades (“você”, "usuário" ou “Cliente”) que adquirem a plataforma de Assinatura Autógrafa
                    Digital (“FAD”) e serviços ou produtos adicionais relacionados (“Produtos”).<br>
                    Ao acessar nossa plataforma e/ou adquirir qualquer um dos nossos Produtos ou Serviços, você declara
                    ser maior de idade (18 anos de idade ou mais, ou a maioridade na jurisdição em que você reside), em
                    pleno exercício e usufruto dos seus direitos, aceitando integralmente os presentes Termos. Se você
                    está concordando com estes Termos em nome de uma organização ou entidade, você declara e garante que
                    está autorizado a concordar com estes Termos em nome da organização ou entidade e a vinculá-las a
                    estes Termos (nesse caso, as referências a "você" e nestes Termos, exceto por esta frase, referem-se
                    à organização ou entidade). Se você não concordar com estes Termos, deverá abster-se de utilizar o
                    FAD e/ou adquirir os Produtos e Serviços que lhe são oferecidos.<br>
                    Caso você tenha dúvidas quanto às siglas e alguns termos utilizados, recomendamos fortemente que
                    você realize a leitura do glossário de definições inserido ao final deste Termo e, caso tenha
                    qualquer dúvida, contacte-nos diretamente através do <a
                        style="text-decoration: none; color: black; font-weight: bold;"
                        href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                </p>
                <ol>
                    <li><span>Descrição, Aquisição e Condições de Uso do FAD e/ou Serviços e Produtos adicionais relacionados</span>
                        <br><br>
                        <ol type="a">
                            <li><strong>Descrição do FAD:</strong> O nosso objetivo é fornecer uma plataforma para
                                assinar documentos
                                em qualquer parte do mundo de forma digital e eficiente. A FAD oferece a
                                possibilidade de assinar automaticamente documentos digitais através de meios
                                eletrônicos, sendo perfeitamente válidos como meio de prova de consentimento, já que
                                é uma assinatura autógrafa num meio eletrônico, equivalente a realizada em papel,
                                com plena validade legal.<br><br>
                            </li>

                            <li>
                                <strong>Aquisição:</strong> Para contratar o FAD, é necessário (i) baixar o aplicativo
                                móvel FAD
                                disponível para os sistemas operativos Android e iOS; (ii) consultar o nosso aviso de
                                privacidade; (iii) registar-se e criar um perfil para ser identificado na FAD, (iv)
                                seleccionar o Serviço que pretende contratar e aceitar os termos correspondente e, por
                                fim, (vi) efetuar o pagamento correspondente e começar a utilizar a plataforma FAD para
                                fazer assinaturas autógrafas em dispositivos eletrônicos.<br><br>
                            </li>

                            <li>
                                <strong>Condições de Uso.</strong> O FAD e demais serviços e produtos conexos que
                                oferecemos é pessoal,
                                não exclusivo, temporário e intransferível, só podendo ser realizado o registo de um
                                único usuário. Caso você deseje incluir mais usuários na contratação do serviço que é
                                concedido, contacte-nos por um dos canais de atendimento previstos na cláusula 11 e
                                solicite um orçamento personalizado dentro do nosso horário de expediente das 9:00 às
                                18:00 (Horário de Brasília).<br><br>
                                <ul>
                                    <li>Você, enquanto usuário, é responsável pela utilização dos nossos sites da mesma
                                        forma em que foram concebidos. Através deste Termo, você concorda em navegar
                                        neles de forma respeitosa, sem violar os direitos de propriedade intelectual ou
                                        outros direitos de propriedade da FAD. Você Usuário concorda ainda em utilizar
                                        as informações, conteúdos, serviços e produtos de forma lícita, sem infringir as
                                        disposições deste Termo, a moral ou à ordem pública, e abster-se-á de qualquer
                                        ato que possa infringir os direitos de terceiros ou prejudicar de qualquer forma
                                        o funcionamento dos nossos Sites.<br><br>
                                    </li>
                                    <li>
                                        Da mesma forma, concorda em fornecer informações legais e verdadeiras nos
                                        formulários fornecidos em nossos sites, para acessar ou comprar o Produto e/ou
                                        Serviço.<br><br>
                                    </li>
                                </ul>
                            </li>

                        </ol>
                    </li>
                    <br>

                    <li><span>Planos para Usuários Pessoas Físicas.</span> <br><br>
                        <ol type="a">
                            <li>
                                <strong>Plano Mensal</strong>
                                <p>Ao adquirir o plano mensal pelo preço de lista que aparece em nosso website, o plano
                                    começará a viger a partir do dia em que o contrato é celebrado e terminará até um
                                    dia antes do mês seguinte ao dia em que foi contratado. Contratando a assinatura
                                    mensal você terá direito ao seguinte:</p>
                                <ul>
                                    <li>Vídeo assinatura;</li>
                                    <li>Vídeo de aceitação do acordo;</li>
                                    <li>Constância de conservação</li>
                                    <li>Verificação por número de telefone;</li>
                                    <li>Apoio técnico de nível 1 que terá lugar durante o horário comercial, das 10:00
                                        às 20:00 horas;
                                    </li>
                                    <li>Você pode cancelar o plano mensal a qualquer momento. Se não desejar continuar
                                        com nossos serviços, você deve solicitar o cancelamento, pois se não recebermos
                                        a solicitação, continuaremos descontando os valores periodicamente em seu cartão
                                        para a continuação do serviço contratado.
                                    </li>
                                </ul>
                            </li>
                            <br>
                            <li>
                                <strong>Plano Pré-pago com validade anual</strong>
                                <p>O nosso serviço em plano pré-pago tem uma validade anual e o custo deste dependerá do
                                    número de assinaturas que você queira fazer. Temos os seguintes planos com preços
                                    que
                                    aparecem na nossa lista de preços disponível no nosso website: 10 assinaturas, 20
                                    assinaturas, 50 assinaturas, 100 assinaturas, 200 assinaturas, 500 assinaturas e
                                    1000
                                    assinaturas.</p>
                                <p>O período anual terá início a partir do dia em que o cliente celebrar o contrato, e
                                    terminará após 365 dias corridos do calendário. No final deste período, não será
                                    possível utilizar a quantidade de assinaturas que não foram realizadas durante o
                                    período
                                    em que o Serviço foi contratado. Se o cliente terminar as assinaturas antes do
                                    período
                                    anual do contrato, o contrato será rescindido, uma vez que o objetivo do Serviço do
                                    plano anual pré-pago é prestar o Serviço durante o tempo estipulado acima ou quando
                                    o
                                    número de assinaturas contratadas for consumido, o que ocorrer primeiro.</p>
                                <p>O pagamento correspondente ao plano pré-pago com validade anual será efetuado em
                                    uma única parcela. Ao contratar um plano pré-pago com validade anual você terá
                                    direito
                                    aos seguintes serviços:</p>

                                <ul>
                                    <li>Vídeo assinatura;</li>
                                    <li>Vídeo de aceitação do acordo;</li>
                                    <li>Constância de conservação</li>
                                    <li>Versão web;</li>
                                    <li>Apoio técnico de nível 1 que terá lugar durante o horário comercial, das 10:00
                                        às 20:00 horas;
                                    </li>
                                    <li>Verificação por número de telefone.
                                    </li>
                                </ul>
                            </li>
                            <br>
                            <li>
                                <strong>Produtos Adicionais.</strong>
                                <p>Em qualquer momento, você pode adquirir os seguintes Produtos Adicionais oferecidos
                                    pela FAD a um custo extra, que são descritos em nosso website, onde você encontrará
                                    o seu preço unitário:</p>
                                <ul>
                                    <li>Captura de identificaçao;</li>
                                    <li>OTP através via Whatsapp;</li>
                                    <li>Constância de conservação em Blockchain;</li>
                                    <li>Captura de identificação e validação de assinatura;</li>
                                    <li>Captura de identidade, validação de assinatura e comparação facial com vídeo de
                                        aceitação do acordo;
                                    </li>
                                    <li>Captura de identificação, validação de assinatura, comparação facial com vídeo
                                        de aceitação do acordo e comparação facial com vídeo assinatura.
                                    </li>
                                </ul>
                                <p style="text-align: center; margin: 10px; font-weight: bold">
                                    <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital." style="font-weight: bold;color: #262626; text-decoration: none; cursor: pointer;">Os addOns são vendidos separadamente, para adquirir entre em contato com um consultor de vendas.</a>
                                </p>
                            </li>
                            <br>
                            <li>
                                <strong>Teste Gratuito.</strong>
                                <p>O teste gratuito será aplicável ao Usuário que se registrar em nosso portal e
                                    consistirá em ter acesso a 3 transações de assinatura de forma mensal. Ele permite
                                    que
                                    nossos usuários testem o serviço e tenham a experiência de usar nosso
                                    aplicativo.</p>
                                <p>Para adquirir a versão gratuita é necessário que você preencha o formulário com
                                    nome e endereço de e-mail, sem informações pessoais catalogadas como dados
                                    financeiros.</p>
                                <p style="text-align: center; margin: 10px; font-weight: bold">
                                    "O plano de teste gratuito inclui assinatura pelo aplicativo nativo, assinatura de vídeo e vídeo acordo. Não inclui  módulo para assinatura via web e addOns"
                                </p>
                            </li>
                        </ol>
                    </li>
                    <br>

                    <li><span>Pagamento.</span><br><br>
                        <p>O Cliente concorda em pagar o preço do Serviço mais os impostos relacionados e aceita os
                            diferentes métodos de pagamento que a BIOMETRIC lhe oferece para a subscrição do Serviço,
                            incluindo a compra de produtos adicionais.</p>
                        <p>Sempre que houver atualizações nos preços praticados pela BIOMETRIC, os novos valores serão
                            disponibilizados em seu site oficial. Caberá sempre ao Cliente conferir os preços de venda
                            dos
                            produtos oferecidos pela BIOMETRIC antes de sua aquisição.</p>
                        <p>A fim de fornecer a você o nosso Serviço numa base mensal, se o pagamento do Serviço FAD
                            não for efetuado nas datas aprazadas, será entendido como não contratação e o Serviço será
                            temporariamente suspenso até que o pagamento seja devidamente identificado e compensado.</p>
                        <p>A BIOMETRIC enviará a confirmação e a Nota Fiscal correspondente à contratação do FAD,
                            Serviços ou compra de Produtos para o endereço eletrônico registrado pelo Usuário.</p>
                        <p>Por outro lado, você pode cancelar o nosso serviço e/ou produto no prazo de 7 (sete) dias
                            após a entrega do Serviço (ou seja, quando estiverem liberados os acessos ao portal FAD),
                            sem
                            responsabilidade ou penalização, sendo reembolsado o preço pago. Você deve solicitar a
                            rescisão
                            destes Termos, Serviço e/ou Produto através do e-mail <a
                                    style="text-decoration: none; color: black; font-weight: bold;"
                                    href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a></p>
                        <p>É importante mencionar que o pagamento é efetuado por meio do portal do provedor Stripe,
                            portanto a utilização deste método de pagamento está sujeita aos termos e condições de
                            serviço e
                            reembolso da Stripe. A BIOMETRIC não é responsável pelo tempo de operação e procedimentos
                            estipulados que se encontram na página da Stripe.</p>
                        <p>Por meio desta plataforma pode-se realizar o pagamento via cartão de crédito (Visa e
                            Mastercard) e boleto bancário.</p>
                        <br>
                    </li>
                    <br>
                    <li><span>Ativação do FAD, Serviços e/ou Produtos</span><br><br>
                        <p>Uma vez concluído o pagamento, a BIOMETRIC enviará para o seu e-mail, no prazo de 48
                            (quarenta e oito) horas após a compra, a confirmação da compra e a chave de acesso para a
                            utilização dos Serviços e/ou Produtos FAD, bem como um vídeo com um guia para a utilização
                            dos
                            Serviços FAD e um diagrama do processo de assinatura digital. O Serviço pode ser obtido
                            diretamente em nosso website com a palavra-passe que lhe foi enviada; a informação sobre a
                            utilização da plataforma digital estará disponível para download nos sistemas operacionais
                            iOS e
                            Android.</p>
                        <p>Os Serviços podem mudar ou melhorar, e é por isso que manteremos você informado das
                            atualizações da BIOMETRIC, promoções do mês, novos serviços ou melhorias e novos produtos
                            através de: telefone, e-mail, Whatsapp, celular, e nos nossos Sites e Redes Sociais.</p>
                    </li>
                    <br>
                    <li><span>Coleta e Proteção de Dados Pessoais</span><br><br>
                        <p>Para a BIOMETRIC é muito importante cuidar das informações pessoais que você fornece
                            diretamente no nosso website e/ou Plataforma Digital e/ou Redes Sociais, em conformidade com
                            as
                            disposições da LGPD (Lei Geral de Proteção de Dados), os seus Regulamentos e outras
                            diretrizes
                            nacionais e internacionais sobre Proteção de Dados. Por essa razão, comprometemo-nos a
                            cumprir
                            respectivas normas, estando todas as informações sobre como tratamos seus dados pessoais
                            disponíveis em: <a style="text-decoration: none; color: black; font-weight: bold;"
                                               [routerLink]="['/aviso-de-privacidade']">Aviso de Privacidade</a></p>
                        <p>O tratamento de dados pessoais por terceiros com os quais você utiliza os nossos serviços
                            será da sua responsabilidade e tal tratamento será por políticas de privacidade distintas,
                            razão
                            pela qual a BIOMETRIC recomenda que você leia e entenda respectivas políticas
                            disponibilizadas
                            por estes terceiros.</p>
                        <p>Links externos em nossos sites: Em nosso website <a
                                style="text-decoration: none; color: black; font-weight: bold;"
                                href="www.assinaturaautografadigital.com.br"> Assinatura Autografa</a>
                            inclui hiperlinks ou links a terceiros, o principal objetivo destes links é melhorar a
                            experiência do usuário, permitindo-lhe acessar ao nosso portal através de redes sociais para
                            solicitar informações e/ou apoio técnico FAD (através do Whatsapp) e método de pagamento
                            (Stripe), portanto nem a disponibilidade, exatidão, veracidade, validade ou legalidade dos
                            websites externos serão garantidas; A FAD não assume qualquer responsabilidade por quaisquer
                            danos que possam resultar do acesso ou utilização de conteúdos, produtos ou serviços
                            disponíveis
                            através de links ou hiperlinks que não sejam geridos pela FAD.Cookies.</p>
                    </li>
                    <br>
                    <li><span>Propriedade Intelectual</span><br><br>
                        <p>O software, website, plataforma digital, design, produtos adicionais, algoritmos, marcas
                            comerciais, e quaisquer outros direitos de propriedade intelectual relacionados com o
                            Serviço ou
                            Produtos de software que são objeto deste contrato serão considerados propriedade exclusiva
                            da
                            BIOMETRIC.</p>
                        <p>É estritamente proibido fazer qualquer tipo de reprodução, cópia, disponibilização a
                            terceiros, modificação, descompilação, ajustes ou quaisquer outros atos que violem os
                            direitos
                            de propriedade intelectual da BIOMETRIC. A adulteração do sistema poderá constituir uma
                            violação
                            das leis nº 9.609 de 19 de fevereiro de 1998, Lei nº. 9.610, de 19 de fevereiro de 1998 e
                            Lei nº
                            9.279, de 14 de maio de 1996, e poderá dar origem ao pagamento de danos e isentará a
                            BIOMETRIC
                            de qualquer responsabilidade por qualquer falha do sistema em resultado de tais modificações
                            não
                            autorizadas.</p>
                        <p>A BIOMETRIC concede a você uma garantia contra quaisquer ações, reivindicações e/ou
                            indenizações legais que possam ser advindas de um terceiro em relação à propriedade ou os
                            direitos de autor sobre o Serviço de software e Produtos adicionais oferecidos no nosso
                            website
                            e plataforma digital, objeto dos presentes Termos. Em caso de tal eventualidade, você deverá
                            notificar por escrito a BIOMETRIC para que esta tome as medidas legais apropriadas.</p>
                    </li>
                    <br>
                    <li><span>Propriedade Intelectual</span><br><br>
                        <p>Sem prejuízo das limitações de responsabilidade já determinadas nestes Termos, não concedemos
                            qualquer responsabilidade ou garantia nos seguintes casos:</p>
                        <ul>
                            <li>Você pode cancelar o Serviço FAD em qualquer momento, com a ressalva de que, após
                                passados os 7 dias garantidos pelo Código de Defesa do Consumidor (art. 49 do CDC), não
                                haverá reembolsos por cancelamento. Em caso de suspensão do serviço, o Cliente concorda
                                que
                                não receberá qualquer reembolso ou compensação.
                            </li>

                            <li>As deficiências do seu dispositivo eletrônico que não conte com a capacidade suficiente
                                de suporte ou tecnológica da BIOMETRIC.
                            </li>

                            <li>Violações cometidas por você ou terceiros, que estejam associadas ao uso indevido e/ou
                                alteração do software FAD e/ou nossos sites, que poderia causar o mau funcionamento do
                                seu
                                dispositivo eletrônico, bem como de terceiros, como defeitos, falhas, abusos, acidentes,
                                negligência, instalação, operação ou manutenção inadequada, vandalismo de computador,
                                atos
                                de força maior, atos de terrorismo, interrupções ou picos no fornecimento de energia
                                elétrica, falhas no seu serviço de Internet.
                            </li>

                            <li>A incompatibilidade causada por um hardware e / ou software competente instalado em seus
                                dispositivos eletrônicos. Você concorda em atualizar a Plataforma Digital da BIOMETRIC,
                                sempre que for avisado por e-mail, celular, telefone fixo, pelo WhatsApp, Site ou por
                                qualquer meio de suas novas melhorias ou versões.
                            </li>

                            <li>A utilização ilícita da plataforma. A BIOMETRIC não é responsável pela assinatura de
                                documentos ilícitos que o usuário faz dentro da FAD, renunciamos a qualquer
                                responsabilidade
                                legal pelo uso ilícito que faz com terceiros ou com as pessoas dentro da sua empresa,
                                uma
                                vez que não temos visibilidade do conteúdo dentro dos documentos. A BIOMETRIC somente
                                tem
                                acesso aos dados pessoais durante o processo de assinatura para validação dos
                                documentos.
                            </li>

                            <li>Fornecemos apoio técnico e garantia dos nossos serviços, portanto, se você não puder
                                realizar o processo de assinatura autógrafa digital e/ou Produtos adicionais que
                                adquiriu,
                                devido a problemas técnicos em nossos sites, que possam surgir da nossa parte, a
                                BIOMETRIC
                                procederá ao desconto do valor das assinaturas que não puderam ser realizadas. Esta
                                garantia
                                será aplicável desde que você notifique previamente a área de apoio técnico da BIOMETRIC
                                (esta garantia será válida para a contratação do plano pré-pago com validade anual).
                            </li>

                            <li>Da mesma forma, na BIOMETRIC oferecemos garantia dos nossos Serviços, na contratação do
                                plano de assinatura mensal, concedendo-lhe mais um dia do Serviço para a assinatura que
                                não
                                conseguiu realizar devido a problemas técnicos em nossos sites, que possam surgir da
                                nossa
                                parte.
                            </li>

                            <li>Exclusão de responsabilidade: Nossa plataforma está disponível "no estado em que se
                                encontra", portanto o usuário declara sua concordância com relação às presentes
                                características e conteúdo, portanto, a BIOMETRIC se isenta de qualquer responsabilidade
                                quanto à indisponibilidade de conexões, links ou seus conteúdos por motivos que não são
                                diretamente atribuíveis a ele, por exemplo: falhas no serviço de internet ou dados,
                                ataques
                                externos, desastres naturais, causas de força maior ou perda de conteúdo, ou falhas
                                atribuíveis a terceiros prestadores de serviços de informática na nuvem, fornecedores
                                externos na qualidade de administradores da plataforma ou intermitências na conexão com
                                eles.
                            </li>
                        </ul>
                        <p>
                            O usuário, desde já, concorda que qualquer dano oriundo de culpa, causado exclusivamente por
                            problemas da plataforma FAD e demais serviços e produtos conexos, terá como limite de
                            indenização o valor anual pago pelo usuário para utilização do FAD. Respectiva limitação não
                            ocorrerá em caso de danos praticados com dolo ou culpa grave.
                        </p>
                    </li>
                    <br>
                    <li><span>Segurança da informação</span><br><br>
                        <p>A segurança da informação durante o uso da plataforma e demais serviços depende, em grande
                            parte, da segurança da rede pela qual você o acessa, recomendamos que você não se conecte à
                            nossa plataforma usando serviços públicos de Internet.</p>

                        <p>Informamos que nossos software e Serviços estão hospedados nos servidores de um provedor de
                            serviços de computação em nuvem que atende aos mais altos padrões de segurança da
                            informação.</p>

                        <p>É altamente recomendável instalar antivírus e antimalware em seu dispositivo móvel para
                            evitar que pessoas mal-intencionadas executem programas mal-intencionados que podem colocar
                            as
                            informações em seu computador e suas comunicações em risco.</p>

                    </li>
                    <li><span>Modificações ou atualizações</span><br><br>
                        <p>A BIOMETRIC pode, a qualquer momento e quando julgar apropriado, fazer correções, acréscimos,
                            melhorias ou modificações no conteúdo, apresentação, informações, serviços e outros
                            elementos, sem que seja atribuído ao Usuário qualquer tipo de direito a reclamação ou
                            indenização.</p>
                    </li>
                    <li><span>Confidencialidade da Informação</span><br><br>
                        <p>A BIOMETRIC utilizará as informações fornecidas pelo Usuário de forma confidencial, as quais
                            não serão divulgadas ou transmitidas para fins diferentes dos previstos nestes Termos, a
                            menos que haja autorização expressa por parte do Usuário.</p>
                    </li>
                    <li><span>Informações de Contato</span><br><br>
                        <p>Em caso de reclamação e/ou pedido de esclarecimento relacionados aos Serviços FAD, o Usuário
                            poderá contactar-se por email, telefone ou dirigir-se ao endereço indicado conforme os dados
                            abaixo: BIOMETRIC AGREEMENT DO BRASIL LTDA. Endereço: Alameda Santos 1165, Jardim Paulista,
                            CEP 01419-001, São Paulo/SP. E-mail contato: <a
                                    style="text-decoration: none; color: black; font-weight: bold;"
                                    href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                            Número de telefone de contato: +55 11 99795-6809</p>
                    </li>
                    <li><span>Lei aplicável e Jurisdição</span><br><br>
                        Os Termos aqui descritos são regidos pela legislação da República Federativa do Brasil. Seu
                        texto deverá ser interpretado no idioma português e os usuários do site se submetem ao Foro da
                        Comarca de São Paulo, Capital, para dirimir toda e qualquer controvérsia oriunda deste website,
                        com expressa renúncia de qualquer outro, por mais privilegiado que seja.
                    </li>
                </ol>
                <br>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/telefonos.png">
            </div>

            <div class="content-res">
                <h1>Termos e Condições</h1>
                <p class="text">
                    Data da última atualização 21 de março de 2021
                </p>
                <p class="text">

                    Estes Termos e Condições de uso da Plataforma FAD (“Termos”), regem a aquisição, acesso e utilização
                    da plataforma de Assinatura Autógrafa Digital (“FAD”) e outros serviços e produtos relacionados,
                    comercializados pela <strong>BIOMETRIC AGREEMENT DO BRASIL LTDA (“BIOMETRIC” ou “nós”)</strong>
                    através de nosso
                    aplicativo, Plataforma Digital ou website. Dessa forma, estes Termos vinculam todas aquelas pessoas
                    ou entidades (“você”, "usuário" ou “Cliente”) que adquirem a plataforma de Assinatura Autógrafa
                    Digital (“FAD”) e serviços ou produtos adicionais relacionados (“Produtos”).<br>
                    Ao acessar nossa plataforma e/ou adquirir qualquer um dos nossos Produtos ou Serviços, você declara
                    ser maior de idade (18 anos de idade ou mais, ou a maioridade na jurisdição em que você reside), em
                    pleno exercício e usufruto dos seus direitos, aceitando integralmente os presentes Termos. Se você
                    está concordando com estes Termos em nome de uma organização ou entidade, você declara e garante que
                    está autorizado a concordar com estes Termos em nome da organização ou entidade e a vinculá-las a
                    estes Termos (nesse caso, as referências a "você" e nestes Termos, exceto por esta frase, referem-se
                    à organização ou entidade). Se você não concordar com estes Termos, deverá abster-se de utilizar o
                    FAD e/ou adquirir os Produtos e Serviços que lhe são oferecidos.<br>
                    Caso você tenha dúvidas quanto às siglas e alguns termos utilizados, recomendamos fortemente que
                    você realize a leitura do glossário de definições inserido ao final deste Termo e, caso tenha
                    qualquer dúvida, contacte-nos diretamente através do <a
                        style="text-decoration: none; color: black; font-weight: bold;"
                        href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                </p>
                <ol class="text">
                    <li><span>Descrição, Aquisição e Condições de Uso do FAD e/ou Serviços e Produtos adicionais relacionados</span>
                        <br><br>
                        <ol type="a">
                            <li><strong>Descrição do FAD:</strong> O nosso objetivo é fornecer uma plataforma para
                                assinar documentos
                                em qualquer parte do mundo de forma digital e eficiente. A FAD oferece a
                                possibilidade de assinar automaticamente documentos digitais através de meios
                                eletrônicos, sendo perfeitamente válidos como meio de prova de consentimento, já que
                                é uma assinatura autógrafa num meio eletrônico, equivalente a realizada em papel,
                                com plena validade legal.<br><br>
                            </li>

                            <li>
                                <strong>Aquisição:</strong> Para contratar o FAD, é necessário (i) baixar o aplicativo
                                móvel FAD
                                disponível para os sistemas operativos Android e iOS; (ii) consultar o nosso aviso de
                                privacidade; (iii) registar-se e criar um perfil para ser identificado na FAD, (iv)
                                seleccionar o Serviço que pretende contratar e aceitar os termos correspondente e, por
                                fim, (vi) efetuar o pagamento correspondente e começar a utilizar a plataforma FAD para
                                fazer assinaturas autógrafas em dispositivos eletrônicos.<br><br>
                            </li>

                            <li>
                                <strong>Condições de Uso.</strong> O FAD e demais serviços e produtos conexos que
                                oferecemos é pessoal,
                                não exclusivo, temporário e intransferível, só podendo ser realizado o registo de um
                                único usuário. Caso você deseje incluir mais usuários na contratação do serviço que é
                                concedido, contacte-nos por um dos canais de atendimento previstos na cláusula 11 e
                                solicite um orçamento personalizado dentro do nosso horário de expediente das 9:00 às
                                18:00 (Horário de Brasília).<br><br>
                                <ul>
                                    <li>Você, enquanto usuário, é responsável pela utilização dos nossos sites da mesma
                                        forma em que foram concebidos. Através deste Termo, você concorda em navegar
                                        neles de forma respeitosa, sem violar os direitos de propriedade intelectual ou
                                        outros direitos de propriedade da FAD. Você Usuário concorda ainda em utilizar
                                        as informações, conteúdos, serviços e produtos de forma lícita, sem infringir as
                                        disposições deste Termo, a moral ou à ordem pública, e abster-se-á de qualquer
                                        ato que possa infringir os direitos de terceiros ou prejudicar de qualquer forma
                                        o funcionamento dos nossos Sites.<br><br>
                                    </li>
                                    <li>
                                        Da mesma forma, concorda em fornecer informações legais e verdadeiras nos
                                        formulários fornecidos em nossos sites, para acessar ou comprar o Produto e/ou
                                        Serviço.<br><br>
                                    </li>
                                </ul>
                            </li>

                        </ol>
                    </li>
                    <br>

                    <li><span>Planos para Usuários Pessoas Físicas.</span> <br><br>
                        <ol type="a">
                            <li>
                                <strong>Plano Mensal</strong>
                                <p>Ao adquirir o plano mensal pelo preço de lista que aparece em nosso website, o plano
                                    começará a viger a partir do dia em que o contrato é celebrado e terminará até um
                                    dia antes do mês seguinte ao dia em que foi contratado. Contratando a assinatura
                                    mensal você terá direito ao seguinte:</p>
                                <ul>
                                    <li>Vídeo assinatura;</li>
                                    <li>Vídeo de aceitação do acordo;</li>
                                    <li>Constância de conservação</li>
                                    <li>Verificação por número de telefone;</li>
                                    <li>Apoio técnico de nível 1 que terá lugar durante o horário comercial, das 10:00
                                        às 20:00 horas;
                                    </li>
                                    <li>Você pode cancelar o plano mensal a qualquer momento. Se não desejar continuar
                                        com nossos serviços, você deve solicitar o cancelamento, pois se não recebermos
                                        a solicitação, continuaremos descontando os valores periodicamente em seu cartão
                                        para a continuação do serviço contratado.
                                    </li>
                                </ul>
                            </li>
                            <br>
                            <li>
                                <strong>Plano Pré-pago com validade anual</strong>
                                <p>O nosso serviço em plano pré-pago tem uma validade anual e o custo deste dependerá do
                                    número de assinaturas que você queira fazer. Temos os seguintes planos com preços
                                    que
                                    aparecem na nossa lista de preços disponível no nosso website: 10 assinaturas, 20
                                    assinaturas, 50 assinaturas, 100 assinaturas, 200 assinaturas, 500 assinaturas e
                                    1000
                                    assinaturas.</p>
                                <p>O período anual terá início a partir do dia em que o cliente celebrar o contrato, e
                                    terminará após 365 dias corridos do calendário. No final deste período, não será
                                    possível utilizar a quantidade de assinaturas que não foram realizadas durante o
                                    período
                                    em que o Serviço foi contratado. Se o cliente terminar as assinaturas antes do
                                    período
                                    anual do contrato, o contrato será rescindido, uma vez que o objetivo do Serviço do
                                    plano anual pré-pago é prestar o Serviço durante o tempo estipulado acima ou quando
                                    o
                                    número de assinaturas contratadas for consumido, o que ocorrer primeiro.</p>
                                <p>O pagamento correspondente ao plano pré-pago com validade anual será efetuado em
                                    uma única parcela. Ao contratar um plano pré-pago com validade anual você terá
                                    direito
                                    aos seguintes serviços:</p>

                                <ul>
                                    <li>Vídeo assinatura;</li>
                                    <li>Vídeo de aceitação do acordo;</li>
                                    <li>Constância de conservação</li>
                                    <li>Versão web;</li>
                                    <li>Apoio técnico de nível 1 que terá lugar durante o horário comercial, das 10:00
                                        às 20:00 horas;
                                    </li>
                                    <li>Verificação por número de telefone.
                                    </li>
                                </ul>
                            </li>
                            <br>
                            <li>
                                <strong>Produtos Adicionais.</strong>
                                <p>Em qualquer momento, você pode adquirir os seguintes Produtos Adicionais oferecidos
                                    pela FAD a um custo extra, que são descritos em nosso website, onde você encontrará
                                    o seu preço unitário:</p>
                                <ul>
                                    <li>Captura de identificaçao;</li>
                                    <li>OTP através via Whatsapp;</li>
                                    <li>Constância de conservação em Blockchain;</li>
                                    <li>Captura de identificação e validação de assinatura;</li>
                                    <li>Captura de identidade, validação de assinatura e comparação facial com vídeo de
                                        aceitação do acordo;
                                    </li>
                                    <li>Captura de identificação, validação de assinatura, comparação facial com vídeo
                                        de aceitação do acordo e comparação facial com vídeo assinatura.
                                    </li>
                                </ul>
                                <p style="text-align: center; margin: 10px; font-weight: bold">x
                                    <a href="https://api.whatsapp.com/send?phone=5215527560645&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital." style="font-weight: bold;color: #262626; text-decoration: none; cursor: pointer;">Os addOns são vendidos separadamente, para adquirir entre em contato com um consultor de vendas.</a>
                                </p>
                            </li>
                            <br>
                            <li>
                                <strong>Teste Gratuito.</strong>
                                <p>O teste gratuito será aplicável ao Usuário que se registrar em nosso portal e
                                    consistirá em ter acesso a 3 transações de assinatura de forma mensal. Ele permite
                                    que
                                    nossos usuários testem o serviço e tenham a experiência de usar nosso
                                    aplicativo.</p>
                                <p>Para adquirir a versão gratuita é necessário que você preencha o formulário com
                                    nome e endereço de e-mail, sem informações pessoais catalogadas como dados
                                    financeiros.</p>
                                <p style="text-align: center; margin: 10px; font-weight: bold">
                                    "O plano de teste gratuito inclui assinatura pelo aplicativo nativo, assinatura de vídeo e vídeo acordo. Não inclui  módulo para assinatura via web e addOns"
                                </p>
                            </li>
                        </ol>
                    </li>
                    <br>

                    <li><span>Pagamento.</span><br><br>
                        <p>O Cliente concorda em pagar o preço do Serviço mais os impostos relacionados e aceita os
                            diferentes métodos de pagamento que a BIOMETRIC lhe oferece para a subscrição do Serviço,
                            incluindo a compra de produtos adicionais.</p>
                        <p>Sempre que houver atualizações nos preços praticados pela BIOMETRIC, os novos valores serão
                            disponibilizados em seu site oficial. Caberá sempre ao Cliente conferir os preços de venda
                            dos
                            produtos oferecidos pela BIOMETRIC antes de sua aquisição.</p>
                        <p>A fim de fornecer a você o nosso Serviço numa base mensal, se o pagamento do Serviço FAD
                            não for efetuado nas datas aprazadas, será entendido como não contratação e o Serviço será
                            temporariamente suspenso até que o pagamento seja devidamente identificado e compensado.</p>
                        <p>A BIOMETRIC enviará a confirmação e a Nota Fiscal correspondente à contratação do FAD,
                            Serviços ou compra de Produtos para o endereço eletrônico registrado pelo Usuário.</p>
                        <p>Por outro lado, você pode cancelar o nosso serviço e/ou produto no prazo de 7 (sete) dias
                            após a entrega do Serviço (ou seja, quando estiverem liberados os acessos ao portal FAD),
                            sem
                            responsabilidade ou penalização, sendo reembolsado o preço pago. Você deve solicitar a
                            rescisão
                            destes Termos, Serviço e/ou Produto através do e-mail <a
                                    style="text-decoration: none; color: black; font-weight: bold;"
                                    href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a></p>
                        <p>É importante mencionar que o pagamento é efetuado por meio do portal do provedor Stripe,
                            portanto a utilização deste método de pagamento está sujeita aos termos e condições de
                            serviço e
                            reembolso da Stripe. A BIOMETRIC não é responsável pelo tempo de operação e procedimentos
                            estipulados que se encontram na página da Stripe.</p>
                        <p>Por meio desta plataforma pode-se realizar o pagamento via cartão de crédito (Visa e
                            Mastercard) e boleto bancário.</p>
                        <br>
                    </li>
                    <br>
                    <li><span>Ativação do FAD, Serviços e/ou Produtos</span><br><br>
                        <p>Uma vez concluído o pagamento, a BIOMETRIC enviará para o seu e-mail, no prazo de 48
                            (quarenta e oito) horas após a compra, a confirmação da compra e a chave de acesso para a
                            utilização dos Serviços e/ou Produtos FAD, bem como um vídeo com um guia para a utilização
                            dos
                            Serviços FAD e um diagrama do processo de assinatura digital. O Serviço pode ser obtido
                            diretamente em nosso website com a palavra-passe que lhe foi enviada; a informação sobre a
                            utilização da plataforma digital estará disponível para download nos sistemas operacionais
                            iOS e
                            Android.</p>
                        <p>Os Serviços podem mudar ou melhorar, e é por isso que manteremos você informado das
                            atualizações da BIOMETRIC, promoções do mês, novos serviços ou melhorias e novos produtos
                            através de: telefone, e-mail, Whatsapp, celular, e nos nossos Sites e Redes Sociais.</p>
                    </li>
                    <br>
                    <li><span>Coleta e Proteção de Dados Pessoais</span><br><br>
                        <p>Para a BIOMETRIC é muito importante cuidar das informações pessoais que você fornece
                            diretamente no nosso website e/ou Plataforma Digital e/ou Redes Sociais, em conformidade com
                            as
                            disposições da LGPD (Lei Geral de Proteção de Dados), os seus Regulamentos e outras
                            diretrizes
                            nacionais e internacionais sobre Proteção de Dados. Por essa razão, comprometemo-nos a
                            cumprir
                            respectivas normas, estando todas as informações sobre como tratamos seus dados pessoais
                            disponíveis em: <a style="text-decoration: none; color: black; font-weight: bold;"
                                               [routerLink]="['/aviso-de-privacidade']">Aviso de Privacidade</a></p>
                        <p>O tratamento de dados pessoais por terceiros com os quais você utiliza os nossos serviços
                            será da sua responsabilidade e tal tratamento será por políticas de privacidade distintas,
                            razão
                            pela qual a BIOMETRIC recomenda que você leia e entenda respectivas políticas
                            disponibilizadas
                            por estes terceiros.</p>
                        <p>Links externos em nossos sites: Em nosso website <a
                                style="text-decoration: none; color: black; font-weight: bold;"
                                href="www.assinaturaautografadigital.com.br"> Assinatura Autografa</a>
                            inclui hiperlinks ou links a terceiros, o principal objetivo destes links é melhorar a
                            experiência do usuário, permitindo-lhe acessar ao nosso portal através de redes sociais para
                            solicitar informações e/ou apoio técnico FAD (através do Whatsapp) e método de pagamento
                            (Stripe), portanto nem a disponibilidade, exatidão, veracidade, validade ou legalidade dos
                            websites externos serão garantidas; A FAD não assume qualquer responsabilidade por quaisquer
                            danos que possam resultar do acesso ou utilização de conteúdos, produtos ou serviços
                            disponíveis
                            através de links ou hiperlinks que não sejam geridos pela FAD.Cookies.</p>
                    </li>
                    <br>
                    <li><span>Propriedade Intelectual</span><br><br>
                        <p>O software, website, plataforma digital, design, produtos adicionais, algoritmos, marcas
                            comerciais, e quaisquer outros direitos de propriedade intelectual relacionados com o
                            Serviço ou
                            Produtos de software que são objeto deste contrato serão considerados propriedade exclusiva
                            da
                            BIOMETRIC.</p>
                        <p>É estritamente proibido fazer qualquer tipo de reprodução, cópia, disponibilização a
                            terceiros, modificação, descompilação, ajustes ou quaisquer outros atos que violem os
                            direitos
                            de propriedade intelectual da BIOMETRIC. A adulteração do sistema poderá constituir uma
                            violação
                            das leis nº 9.609 de 19 de fevereiro de 1998, Lei nº. 9.610, de 19 de fevereiro de 1998 e
                            Lei nº
                            9.279, de 14 de maio de 1996, e poderá dar origem ao pagamento de danos e isentará a
                            BIOMETRIC
                            de qualquer responsabilidade por qualquer falha do sistema em resultado de tais modificações
                            não
                            autorizadas.</p>
                        <p>A BIOMETRIC concede a você uma garantia contra quaisquer ações, reivindicações e/ou
                            indenizações legais que possam ser advindas de um terceiro em relação à propriedade ou os
                            direitos de autor sobre o Serviço de software e Produtos adicionais oferecidos no nosso
                            website
                            e plataforma digital, objeto dos presentes Termos. Em caso de tal eventualidade, você deverá
                            notificar por escrito a BIOMETRIC para que esta tome as medidas legais apropriadas.</p>
                    </li>
                    <br>
                    <li><span>Propriedade Intelectual</span><br><br>
                        <p>Sem prejuízo das limitações de responsabilidade já determinadas nestes Termos, não concedemos
                            qualquer responsabilidade ou garantia nos seguintes casos:</p>
                        <ul>
                            <li>Você pode cancelar o Serviço FAD em qualquer momento, com a ressalva de que, após
                                passados os 7 dias garantidos pelo Código de Defesa do Consumidor (art. 49 do CDC), não
                                haverá reembolsos por cancelamento. Em caso de suspensão do serviço, o Cliente concorda
                                que
                                não receberá qualquer reembolso ou compensação.
                            </li>

                            <li>As deficiências do seu dispositivo eletrônico que não conte com a capacidade suficiente
                                de suporte ou tecnológica da BIOMETRIC.
                            </li>

                            <li>Violações cometidas por você ou terceiros, que estejam associadas ao uso indevido e/ou
                                alteração do software FAD e/ou nossos sites, que poderia causar o mau funcionamento do
                                seu
                                dispositivo eletrônico, bem como de terceiros, como defeitos, falhas, abusos, acidentes,
                                negligência, instalação, operação ou manutenção inadequada, vandalismo de computador,
                                atos
                                de força maior, atos de terrorismo, interrupções ou picos no fornecimento de energia
                                elétrica, falhas no seu serviço de Internet.
                            </li>

                            <li>A incompatibilidade causada por um hardware e / ou software competente instalado em seus
                                dispositivos eletrônicos. Você concorda em atualizar a Plataforma Digital da BIOMETRIC,
                                sempre que for avisado por e-mail, celular, telefone fixo, pelo WhatsApp, Site ou por
                                qualquer meio de suas novas melhorias ou versões.
                            </li>

                            <li>A utilização ilícita da plataforma. A BIOMETRIC não é responsável pela assinatura de
                                documentos ilícitos que o usuário faz dentro da FAD, renunciamos a qualquer
                                responsabilidade
                                legal pelo uso ilícito que faz com terceiros ou com as pessoas dentro da sua empresa,
                                uma
                                vez que não temos visibilidade do conteúdo dentro dos documentos. A BIOMETRIC somente
                                tem
                                acesso aos dados pessoais durante o processo de assinatura para validação dos
                                documentos.
                            </li>

                            <li>Fornecemos apoio técnico e garantia dos nossos serviços, portanto, se você não puder
                                realizar o processo de assinatura autógrafa digital e/ou Produtos adicionais que
                                adquiriu,
                                devido a problemas técnicos em nossos sites, que possam surgir da nossa parte, a
                                BIOMETRIC
                                procederá ao desconto do valor das assinaturas que não puderam ser realizadas. Esta
                                garantia
                                será aplicável desde que você notifique previamente a área de apoio técnico da BIOMETRIC
                                (esta garantia será válida para a contratação do plano pré-pago com validade anual).
                            </li>

                            <li>Da mesma forma, na BIOMETRIC oferecemos garantia dos nossos Serviços, na contratação do
                                plano de assinatura mensal, concedendo-lhe mais um dia do Serviço para a assinatura que
                                não
                                conseguiu realizar devido a problemas técnicos em nossos sites, que possam surgir da
                                nossa
                                parte.
                            </li>

                            <li>Exclusão de responsabilidade: Nossa plataforma está disponível "no estado em que se
                                encontra", portanto o usuário declara sua concordância com relação às presentes
                                características e conteúdo, portanto, a BIOMETRIC se isenta de qualquer responsabilidade
                                quanto à indisponibilidade de conexões, links ou seus conteúdos por motivos que não são
                                diretamente atribuíveis a ele, por exemplo: falhas no serviço de internet ou dados,
                                ataques
                                externos, desastres naturais, causas de força maior ou perda de conteúdo, ou falhas
                                atribuíveis a terceiros prestadores de serviços de informática na nuvem, fornecedores
                                externos na qualidade de administradores da plataforma ou intermitências na conexão com
                                eles.
                            </li>
                        </ul>
                        <p>
                            O usuário, desde já, concorda que qualquer dano oriundo de culpa, causado exclusivamente por
                            problemas da plataforma FAD e demais serviços e produtos conexos, terá como limite de
                            indenização o valor anual pago pelo usuário para utilização do FAD. Respectiva limitação não
                            ocorrerá em caso de danos praticados com dolo ou culpa grave.
                        </p>
                    </li>
                    <br>
                    <li><span>Segurança da informação</span><br><br>
                        <p>A segurança da informação durante o uso da plataforma e demais serviços depende, em grande
                            parte, da segurança da rede pela qual você o acessa, recomendamos que você não se conecte à
                            nossa plataforma usando serviços públicos de Internet.</p>

                        <p>Informamos que nossos software e Serviços estão hospedados nos servidores de um provedor de
                            serviços de computação em nuvem que atende aos mais altos padrões de segurança da
                            informação.</p>

                        <p>É altamente recomendável instalar antivírus e antimalware em seu dispositivo móvel para
                            evitar que pessoas mal-intencionadas executem programas mal-intencionados que podem colocar
                            as
                            informações em seu computador e suas comunicações em risco.</p>

                    </li>
                    <li><span>Modificações ou atualizações</span><br><br>
                        <p>A BIOMETRIC pode, a qualquer momento e quando julgar apropriado, fazer correções, acréscimos,
                            melhorias ou modificações no conteúdo, apresentação, informações, serviços e outros
                            elementos, sem que seja atribuído ao Usuário qualquer tipo de direito a reclamação ou
                            indenização.</p>
                    </li>
                    <li><span>Confidencialidade da Informação</span><br><br>
                        <p>A BIOMETRIC utilizará as informações fornecidas pelo Usuário de forma confidencial, as quais
                            não serão divulgadas ou transmitidas para fins diferentes dos previstos nestes Termos, a
                            menos que haja autorização expressa por parte do Usuário.</p>
                    </li>
                    <li><span>Informações de Contato</span><br><br>
                        <p>Em caso de reclamação e/ou pedido de esclarecimento relacionados aos Serviços FAD, o Usuário
                            poderá contactar-se por email, telefone ou dirigir-se ao endereço indicado conforme os dados
                            abaixo: BIOMETRIC AGREEMENT DO BRASIL LTDA. Endereço: Alameda Santos 1165, Jardim Paulista,
                            CEP 01419-001, São Paulo/SP. E-mail contato: <a
                                    style="text-decoration: none; color: black; font-weight: bold;"
                                    href="mailto:suporte@assinaturaautografadigital.com.br">Suporte</a>
                            Número de telefone de contato: +55 11 99795-6809</p>
                    </li>
                    <li><span>Lei aplicável e Jurisdição</span><br><br>
                        Os Termos aqui descritos são regidos pela legislação da República Federativa do Brasil. Seu
                        texto deverá ser interpretado no idioma português e os usuários do site se submetem ao Foro da
                        Comarca de São Paulo, Capital, para dirimir toda e qualquer controvérsia oriunda deste website,
                        com expressa renúncia de qualquer outro, por mais privilegiado que seja.
                    </li>
                </ol>
            </div>

        </div>
    </div>

</app-template>
